import { makeObservable, observable, action } from 'mobx';

var WageringStore = /** @class */ (function () {
    function WageringStore() {
        this.partnerWageringOdd = null;
        makeObservable(this, {
            partnerWageringOdd: observable,
            setPartnerWageringOdd: action.bound,
        });
    }
    WageringStore.prototype.setPartnerWageringOdd = function (partnerWageringOdd) {
        this.partnerWageringOdd = partnerWageringOdd;
    };
    return WageringStore;
}());
var wageringStore = new WageringStore();

export { WageringStore, wageringStore };
